import React from 'react';

interface IIconProps {
  className?: string;
  pathClass?: string;
  size: number;
}

const ClockIcon = ({className, pathClass, size}: IIconProps) =>
  <svg className={className} width={size + "px"} height={size + "px"} viewBox="0 0 40 40" aria-labelledby="title">
    <title id="title">Clock Icon</title>
    <path
      className={pathClass}
      d="M20,37.5 C10.3350169,37.5 2.5,29.6649831 2.5,20 C2.5,10.3350169 10.3350169,2.5 20,2.5 C29.6649831,2.5 37.5,10.3350169 37.5,20 C37.5,29.6649831 29.6649831,37.5 20,37.5 Z M20.078125,34.765625 C28.1898073,34.765625 34.765625,28.1898073 34.765625,20.078125 C34.765625,11.9664427 28.1898073,5.390625 20.078125,5.390625 C11.9664427,5.390625 5.390625,11.9664427 5.390625,20.078125 C5.390625,28.1898073 11.9664427,34.765625 20.078125,34.765625 Z M18.59375,11.7117705 C18.59375,10.93512 19.2233496,10.3055205 20,10.3055205 C20.7766504,10.3055205 21.40625,10.93512 21.40625,11.7117705 L21.40625,19.6805205 L27.421875,19.6805205 C28.1985254,19.6805205 28.828125,20.31012 28.828125,21.0867705 C28.828125,21.8634209 28.1985254,22.4930205 27.421875,22.4930205 L21.40625,22.4930205 C19.8529491,22.4930205 18.59375,21.2338213 18.59375,19.6805205 L18.59375,11.7117705 Z"
    />
  </svg>
;

export default ClockIcon;


// WEBPACK FOOTER //
// ./src/components/lib/Icons/ClockIcon/ClockIcon.tsx